<template>
  <Layout>
    <PageHeader />
    <v-app>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="container-xxl-fluid p-3" v-if="checkoutToken">
                <div class="row">
                  <div class="col-lg-6">
                    <h3 class="text-center mb-5">Ödeme Bilgileri</h3>
                    <div class="container">
                      <div class="row">
                        <div class="col-lg-12">
                          <v-text-field
                            class="col-lg-"
                            v-model="valueFields.cardNumber"
                            label="Kart Numarası"
                            v-mask="'#### #### #### ####'"
                            filled
                            solo
                            dense
                            id="v-card-number"
                            ref="v-card-number"
                            data-card-field
                          >
                          </v-text-field>
                        </div>
                        <div class="col-lg-12">
                          <v-text-field
                            v-model="valueFields.cardName"
                            label="Kart Sahibi Ad Soyad"
                            filled
                            solo
                            dense
                            id="v-card-name"
                            ref="v-card-name"
                            data-card-field
                          >
                          </v-text-field>
                        </div>
                        <div class="col-lg-4">
                          <v-select
                            v-model="valueFields.cardMonth"
                            label="AY"
                            filled
                            solo
                            dense
                            id="v-card-month"
                            ref="v-card-month"
                            data-card-field
                            :items="[
                              '01',
                              '02',
                              '03',
                              '04',
                              '05',
                              '06',
                              '07',
                              '08',
                              '09',
                              '10',
                              '11',
                              '12',
                            ]"
                          >
                          </v-select>
                        </div>
                        <div class="col-lg-4">
                          <v-select
                            v-model="valueFields.cardYear"
                            label="YIL"
                            filled
                            solo
                            dense
                            id="v-card-year"
                            ref="v-card-year"
                            data-card-field
                            :items="[
                              2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,
                              2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036,
                              2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044,
                              2045, 2046, 2047, 2048, 2049, 2050,
                            ]"
                          >
                          </v-select>
                        </div>
                        <div class="col-lg-4">
                          <v-text-field
                            v-model="valueFields.cardCvv"
                            label="CVV"
                            filled
                            solo
                            dense
                            ref="v-card-cvv"
                            id="v-card-cvv"
                            v-mask="'###'"
                            data-card-field
                          >
                          </v-text-field>
                        </div>
                        <div class="col-lg-12" v-if="user.RoleGroupId !== '3'">
                          <search-select
                            :search-type="'current'"
                            @itemChange="(e) => (selectedCurrent = e)"
                            :label="'Cari'"
                          >
                          </search-select>
                        </div>
                        <div class="col-lg-12">
                          <v-textarea
                            v-model="paymentNotes"
                            filled
                            solo
                            dense
                            label="Ödeme Notlarınız"
                          >
                          </v-textarea>
                        </div>
                        <div class="col-lg-12 d-flex flex-row">
                          <v-text-field
                            style="width: 77%"
                            :value="formattedAmount"
                            @input="updateAmount"
                            filled
                            solo
                            dense
                            label="Tutar"
                          >
                          </v-text-field>
                          <span
                            style="width: 3%"
                            class="fs-1 d-flex justify-content-center"
                            >{{ "," }}</span
                          >
                          <v-text-field
                            style="width: 20%"
                            v-mask="'##'"
                            v-model="amountDec"
                            filled
                            solo
                            dense
                            suffix="TRY"
                          >
                          </v-text-field>
                        </div>
                        <div>
                          <v-btn
                            @click="submitForm"
                            color="danger darken-1"
                            style="color: white"
                            elevation="3"
                            raised
                            :disabled="inAction"
                            :loading="inAction"
                          >
                            ÖDEME YAP
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <h3 class="text-center mb-5">Önizleme</h3>
                    <VuePaycard
                      :value-fields="valueFields"
                      :has-random-backgrounds="true"
                      :labels="labels"
                      :is-card-number-masked="false"
                      :bank-image="imagePath"
                      style="z-index: 1 !important"
                    ></VuePaycard>
                    <div class="mt-16">
                      <v-card
                        ripple
                        class="d-flex flex-row align-center align-middle hover"
                        style="max-height: 70px"
                        @click="selectedInstallment = { installment: 0 }"
                      >
                        <v-col cols="2" class="d-flex">
                          <v-checkbox
                            :on-icon="'mdi-checkbox-marked-circle-outline'"
                            :off-icon="'mdi-radiobox-blank'"
                            v-model="selectedInstallment"
                            :true-value="{ installment: 0 }"
                            :false-value="false"
                            color="info"
                          >
                          </v-checkbox>
                        </v-col>
                        <v-col cols="4" class="d-flex flex-column">
                          <span class="fs-4">{{ "Tek Çekim" }}</span>
                        </v-col>
                        <v-col cols="6" class="text-right align-end">
                          <span class="fs-4">
                            {{ setTotalAmount + " TRY" }}</span
                          >
                        </v-col>
                      </v-card>
                      <v-card
                        ripple
                        v-for="(item, i) in binData"
                        :key="i"
                        class="d-flex flex-row align-center align-middle"
                        style="max-height: 70px"
                        @click="selectedInstallment = item"
                      >
                        <v-col cols="2">
                          <v-checkbox
                            :on-icon="'mdi-checkbox-marked-circle-outline'"
                            :off-icon="'mdi-radiobox-blank'"
                            v-model="selectedInstallment"
                            :true-value="item"
                            :false-value="false"
                            color="info"
                          >
                          </v-checkbox>
                        </v-col>
                        <v-col cols="4" class="d-flex flex-column">
                          <span class="fs-4"
                            >Taksit: {{ item.installment }}</span
                          >
                          <span class="fs-5"
                            >Taksit Oranı: {{ item.installmentRate }}</span
                          >
                        </v-col>
                        <v-col cols="6" class="text-right align-end">
                          <span class="fs-4">
                            {{
                              setTotalRateAmount(item.installmentRate) + " TRY"
                            }}
                          </span>
                        </v-col>
                      </v-card>
                    </div>
                  </div>
                </div>
                <ConfirmPaymentDialog
                  :show-dialog="showDialog"
                  :payment-html="paymentHtml"
                  @iframeLoaded="sendSignalR"
                  @show-dialog="changeDialog"
                  :confirmLoading="confirmLoading"
                ></ConfirmPaymentDialog>
              </div>
              <div v-else class="mt-10">
                <div
                  v-if="!checkoutLoginLoading"
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span class="fs-4 fw-medium" style="color: red">
                    {{ "Sanal Pos Modülünüz Aktif Değildir." }}
                  </span>
                </div>
                <div
                  v-else
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <b-spinner
                    variant="primary"
                    size="xl"
                    label="Text Centered"
                  ></b-spinner>
                  <span class="fs-4 fw-medium">
                    {{ "Yükleniyor" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-app>
  </Layout>
</template>

<script lang="ts">
import { mapActions, mapState } from "vuex";
import axios from "axios";
import ConfirmPaymentDialog from "./ConfirmPaymentDialog.vue";
import SearchSelect from "../searchSelect.vue";
import EncryptionHelper from "../../../helpers";
import * as signalR from "@microsoft/signalr";
import Layout from "../../pages/layout/main";
import PageHeader from "../../components/page-header";

export default {
  name: "ParamPos",
  components: {
    SearchSelect,
    ConfirmPaymentDialog,
    Layout,
    PageHeader,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("virtualPayment", ["checkoutToken", "checkoutLoginLoading"]),
    setTotalAmount() {
      let decAmount = `,${this.amountDec}`;
      let amount = this.amount == "" ? "0" : this.formattedAmount;
      let endValue = amount + decAmount;
      return endValue;
    },
    formattedAmount() {
      return this.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  created() {
    this.currentOrigin = window.location.origin;
  },
  mounted() {
    this.sendTokenToDb();
    this.getIpFromAmazon();
    // SignalR bağlantısını başlat
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("https://checkout.ofiscom.net/paymentHub", {
        withCredentials: true,
      })
      .build();

    // Bağlantıyı başlat
    this.connection.start().catch((err) => console.error(err.toString()));

    // Server'dan gelen ödeme kimliği mesajını dinle
    this.connection.on("ReceivePaymentIdForClient", (testId) => {
      switch (testId) {
        case 10:
          this.confirmLoading = 1;
          break;
        case 20:
          this.confirmLoading = 2;
          break;
        case 30:
          this.confirmLoading = 3;
          break;
        default:
          break;
      }
    });
  },
  data() {
    return {
      inAction: false,
      confirmLoading: 1,
      testId: "",
      amountDec: "00",
      selectedBank: "",
      imagePath: "",
      totalAmount: "",
      selectedInstalmentRate: null,
      selectedInstallment: { installment: 0 },
      binData: [],
      showDialog: false,
      paymentHtml: null,
      amazonIpAdress: "",
      bankId: "",
      cardData: {},
      responseData: null,
      showResponse: false,
      modalUrl: "",
      modalTitle: "",
      currentOrigin: "",
      labels: {
        cardName: "-",
        cardHolder: "KART SAHİBİ AD SOYAD",
        cardMonth: "AA",
        cardYear: "YY",
        cardExpires: "VALID THRU",
        cardCvv: "CVV",
      },
      selectedCurrent: null,
      currentSearchText: "",
      currentSearchResult: null,
      currentSearchLoading: false,
      searchCurrentTimeout: null,
      paymentNotes: null,
      valueFields: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
        cardType: "1",
        gsm: "5551231212",
      },
      amount: "",
      transactiontype: "Auth",
      instalment: 1,
      description: "a",
    };
  },
  methods: {
    ...mapActions("virtualPayment", [
      "checkoutLogin",
      "getBinByPrefix",
      "paymentPay",
      "paymentConfirm",
    ]),
    async sendTokenToDb() {
      await this.checkoutLogin();
    },
    setTotalRateAmount(rate) {
      let decAmount = `,${this.amountDec}`;
      let amount = this.amount == "" ? "0" : this.formattedAmount;
      let endValue = amount + decAmount;
      endValue = endValue.replace(/\./g, "");
      endValue = endValue.replace(/,/g, ".");
      endValue = parseFloat(endValue);
      endValue = (endValue + (endValue * rate) / 100).toFixed(2);
      this.totalAmount = endValue;
      let parts = endValue.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(",");
    },
    updateAmount(value) {
      this.amount = value.replace(/\./g, "");
    },
    async confirmPayment(paymentId) {
      this.inAction = false;
      this.paymentConfirm(paymentId).then((e) => {
        this.paymentHtml = e.data.item;
        this.testId = paymentId;
        this.showDialog = true;
      });
    },
    async getIpFromAmazon() {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://checkip.amazonaws.com/",
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          this.amazonIpAdress = response.data.trim();
        })
        .catch((error) => {
          error;
        });
    },
    async installmentSelection(item) {
      this.selectedInstallment = item.installment;
    },
    async encryptPaymentData(paymentData, securityKey) {
      const encryptionHelper = new EncryptionHelper(securityKey);
      const encryptedData = await encryptionHelper.encrypt(
        JSON.stringify(paymentData)
      );
      return encryptedData;
    },

    broadcastPaymentId() {
      // Server'a ödeme kimliğini gönder
      this.connection
        .invoke("BroadcastPaymentIdToClient", this.testId)
        .catch((err) => console.error(err.toString()));
    },

    async sendSignalR() {
      this.broadcastPaymentId();
    },
    async changeDialog(e) {
      this.showDialog = e;
    },

    async submitForm() {
      this.inAction = true;
      this.getIpFromAmazon();
      const paymentData = {
        erpCustomerCode:
          this.user.RoleGroupId !== "3"
            ? this.selectedCurrent
            : this.user.ErpCode,
        erpSalesPersonCode: this.user.SalesPersonCode || undefined,
        bankId: this.bankId,
        cardHolderName: this.valueFields.cardName,
        cardNumber: this.valueFields.cardNumber.replace(/\s/g, ""),
        expireMonth: this.valueFields.cardMonth,
        expireYear: this.valueFields.cardYear,
        cvvCode: this.valueFields.cardCvv,
        cardType: "CREDIT CARD",
        installment: this.selectedInstallment.installment,
        totalAmount: this.totalAmount,
        currencyIsoCode: "949",
        languageIsoCode: "tr",
        customerIpAddress: this.amazonIpAdress,
        userAgent: navigator.userAgent,
        manufacturerCard: true,
        commonPaymentPage: true,
        bankParameters: {},
      };
      const securityKey =
        "Ofiscom_Security_Key_Ofiscom_Security_Key_Ofiscom_Security_Key_Ofiscom_Security_Key_Ofiscom_Security_Key";
      const encryptedData = await this.encryptPaymentData(
        paymentData,
        securityKey
      );
      await this.paymentPay(encryptedData).then((resp) => {
        this.confirmPayment(resp.item.paymentId);
      });
    },
  },
  watch: {
    "valueFields.cardNumber": async function (newVal) {
      if (newVal.length === 19 || newVal.length === 7 || newVal.length === 16) {
        let value = newVal.substring(0, 7);
        let newPre = value.replace(/\s/g, "");
        let result = await this.getBinByPrefix({
          prefix: newPre,
        });
        this.selectedBank = result.data.item.systemName
          .toString()
          .toLowerCase();
        this.imagePath = result.data.item.logoPath;
        this.bankId = result.data.item.id;
        this.binData = result.data.item.installments;
      }
    },
  },
};
</script>
